<template>
  <div class="text-xs-center">
    <v-layout row justify-center>
      <v-snackbar v-model="values.dialog" :color="values.color || 'info'" :timeout="values.timeout || 3000" left bottom>
        {{ values.text || ''}}
        <v-btn dark flat @click="$store.commit('snackbar/change_values', {dialog: false})">
          <v-icon>{{this.translate('system.button.close.icon')}}</v-icon>
        </v-btn>
      </v-snackbar>
    </v-layout>
  </div>

</template>

<script>
  export default {
    name: 'snackbar',
    computed: {
      values () {
        return this.$store.getters[`snackbar/values`] || ''
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/shared/PSnackbar.vue